var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-listing',{attrs:{"dataType":_vm.dataType,"dataElements":_vm.apiResponse,"selectableColumns":_vm.selectableColumns,"sortableColumns":_vm.sortableColumns,"defaultSortColumn":"Collection","catalogueFields":_vm.catalogueFields,"arrayFields":_vm.arrayFields,"enableEdition":false},on:{"getElements":_vm.getElements}})
}
var staticRenderFns = []

export { render, staticRenderFns }